export default {
  home: 'Home',
  pageNotFound: 'The page you requested does not exist',
  backHome: 'Back to Home',
  promo: 'Promo',
  wallet: 'Wallet',
  earn: 'Earn',
  me: 'Me',
  loginRegister: 'Login / Register',
  walletCenter: 'Deposit',
  withdrawTitle: 'Withdraw',
  notice: 'Notifications',
  support: 'Support',
  back: 'Back',
  close: 'Close',
  deposit: 'Deposit',
  brand: 'BetCorgi',
  copySuccess: 'Copied to clipboard · Copied',
  copyFailed: 'Copy failed, please copy manually',
  search: 'Search',
  /** Floating theme button (demo) */
  theme: {
    menu: 'Theme · Demo',
    aria: 'Switch theme · Demo',
    title: 'Switch theme (demo)',
    darkPurple: 'Deep Purple',
    darkGold: 'Deep Gold',
    lightGold: 'Platinum',
    lightBlue: 'Light Blue',
  },
  /** Time wording (spec 6.2): today / yesterday, ranges, site-time hints, countdowns */
  time: {
    today: 'Today',
    yesterday: 'Yesterday',
    days: '{n}d',
    range: {
      today: 'Today',
      yesterday: 'Yesterday',
      last_7d: 'Last 7 days',
      last_30d: 'Last 30 days',
      this_week: 'This week',
      last_week: 'Last week',
      this_month: 'This month',
      last_month: 'Last month',
    },
    siteTime: 'site time',
    siteTimeWithOffset: 'site time {offset}',
    siteTimeHint: 'Counted in site time ({offset})',
    siteClockNote: ' (site time {offset})',
    siteClockNoteLocal: ' (site time {offset}, {local} your time)',
    siteDate: 'Site date',
    dailyReset: 'Resets daily at 00:00{note}',
    resetIn: 'Resets in',
    expiresIn: 'Expires in {countdown}',
    expiresAt: 'Expires {date}',
    waitHm: '{h} hr {m} min',
    waitH: '{h} hr',
    waitM: '{m} min',
    dailyWindow: '{window} ({zone})',
  },
}
